import ReactDOM from "react-dom/client";
import { BrowserProvider } from "./providers/modal-router.provider";

ReactDOM.createRoot(document.querySelector("#modal-root")!).render(
  <BrowserProvider />
);
